export default "__VITE_ASSET__BsfxCv2f__"